module.exports = __webpack_public_path__ + "img/bigEv_bg.908e3636.png";